import { render, staticRenderFns } from "./CompanyWorkbenchPurchaseOrderForm.vue?vue&type=template&id=1971cc7d"
import script from "./CompanyWorkbenchPurchaseOrderForm.vue?vue&type=script&lang=js"
export * from "./CompanyWorkbenchPurchaseOrderForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports